<template>
    <a class="list-group-item font-weight-bold "
       @click="$emit('click', [text, itemKey, icon])" role="button"><i :class="textIcon" class="fas"></i>{{ text }}</a>
</template>

<script>
export default {
    name: 'MarketSidebar',
    props: {
        text: String,
        icon: String,
        itemKey: String,
    },

    computed: {
        textIcon() {
            if (this.icon !== '' && this.icon !== undefined) {
                return 'fa-' + this.icon + ' mr-2';
            }
            return this.icon;
        },
    },
};
</script>
